import React from "react";
import Loadable from "react-loadable";

import DefaultLayout from "./containers/DefaultLayout";

function Loading() {
	return <div>Loading...</div>;
}

const Users = Loadable({
	loader: () => import("./Components/Users/Users"),
	loading: Loading
});

const Logout = Loadable({
	loader: () => import("./Components/Auth/Logout"),
	loading: Loading
});

const Roles = Loadable({
	loader: () => import("./Components/RoleAndPermissions/Roles"),
	loading: Loading
});

const Dashboard = Loadable({
	loader: () => import("./Components/Dashboard"),
	loading: Loading
});

const Messages = Loadable({
	loader: () => import("./Components/Notifications/Messages"),
	loading: Loading
});

const Sites = Loadable({
	loader: () => import("./Components/Site/Sites"),
	loading: Loading
});

const Locations = Loadable({
	loader: () => import("./Components/Site/Location/Locations"),
	loading: Loading
});

const ChangePassword = Loadable({
	loader: () => import("./Components/Users/Users/ChangePassword"),
	loading: Loading
});

const VisitorManagement = Loadable({
	loader: () => import("./Components/VisitorManagement/VisitorManagement"),
	loading: Loading
});


const Reports = Loadable({
	loader: () => import("./Components/Reports/Report"),
	loading: Loading
});

const ChInVisitors = Loadable({
	loader: () => import("./Components/ChInVisitors/ChInVisitors"),
	loading: Loading
});




const routes = [
	{ path: "/", exact: true, name: "Home", component: DefaultLayout },
	{ path: "/dashboard", name: "Dashboard", component: Dashboard },
	{ path: "/messages", name: "Messages", component: Messages },
	{ path: "/logout", name: "Logout", component: Logout },
	{ path: "/roles", name: "Roles", component: Roles },
	{ path: "/users", name: "Users", component: Users },
	{ path: "/user/changePassword", name: "Users", component: ChangePassword },
	{ path: "/sites", name: "Sites", component: Sites },
	{ path: "/visitormanagement", name: "Visitor Management", component: VisitorManagement },
	{ path: "/reports", name: "Reports", component: Reports },
	{ path: "/chinvisitors", name: "ChInVisitors", component: ChInVisitors },

];

export default routes;
